import classNames from 'classnames'
import React from 'react'

import { GatsbyImage } from '../../logic/shared-types'
import MeasurImage from '../MeasurImage'

import Section, { SectionProps } from './Section'

import './IllustratedSection.scss'

const IllustratedSection = (
  props: SectionProps & { image: GatsbyImage; flip?: boolean },
) => {
  return (
    <Section {...props} className="illustratedSection">
      <div
        className={classNames('illustratedSection__columns', {
          'illustratedSection__columns--flip': props.flip,
        })}
      >
        <div
          className={classNames('illustratedSection__illustration', {
            'illustratedSection__illustration--flip': props.flip,
          })}
        >
          {props.image.gatsbyImageData ? (
            <MeasurImage
              image={props.image.gatsbyImageData}
              imgClassName="rounded"
              objectFit="cover"
              alt={props.image.title ?? ''}
            />
          ) : (
            <img
              className="rounded"
              src={props.image.url}
              alt={props.image.title ?? ''}
            />
          )}
        </div>
        <div className="illustratedSection__content">{props.children}</div>
      </div>
    </Section>
  )
}

export default IllustratedSection
